// noinspection ES6UnusedImports
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import auth from './auth'
import plantModule from './plant/plants';
import {
  cloneDeep
} from 'lodash'
import {
  restoreClasses,
  saveClasses
} from '../plugins/blockPersist'
import CircularJSON from 'circular-json'

const vuexStorage = new VuexPersist({
  key: 'nuform',
  supportCircular: true,
  storage: window.localStorage,
  async saveState(key, state, storage) {
    await storage.setItem(
      key,
      CircularJSON.stringify(saveClasses(cloneDeep(state)))
    )
  },
  restoreState(key, storage) {
    let state = storage.getItem(key)
    if (state && CircularJSON.parse(state)) {
      state = restoreClasses(CircularJSON.parse(state))
    }
    if (state) {
      return state
    }
  }
})

export default new Vuex.Store({
  plugins: [vuexStorage.plugin],
  modules: {
    auth,
    plant: plantModule,
  }
})
